<script>

</script>

<div class="timeline is-centered">
	<slot></slot>
</div>